module.exports = __webpack_public_path__ + "static/img/coin.cbdbe13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/coin.png
// module id = m3S/
// module chunks = 216